<template>
  <div
    class="vb-text"
    :draggable="draggable"
    :class="{ selected: selectedPath == path }"
    @load="(ev) => $emit('update')"
    @click.stop="$emit('select', path)"
    @dragstart.stop="$emit('toDrag', path)"
    @dragover.stop="$event.preventDefault()"
    @drop.stop="$emit('toDrop', path)"
  >
    <div
      class="vb-text-content"
      :style="{
        backgroundColor: data.color || '#CCC'
      }"
    >
      <p>{{ data.text || ' ' }}</p>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'vb-text',
    props: {
      data: {
        required: true
      },
      path: {
        required: true
      },
      draggable: {
        type: Boolean
      },
      selectedPath: {
        type: String
      }
    }
  }
</script>
<style lang="scss" scoped>
  .vb-text {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 13px;
    // font-size: clamp(0em, 0.2em + 1vw, 1em);
    color: #FFF;

    &-content {
      flex-grow: 1;
      padding: 5px 30px;
      border-radius: 100px;
      max-width: 100%;

      p {
        word-break: break-word;
        margin: 0;
      }
    }

    &.selected {
      border: .2rem dashed red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VirtualBookViewer/VirtualBookText.vue